<template>
<div class="mt-3">
  <b-tabs content-class="mt-3" v-on:input="tabChanged()" v-model="searchForm.primaryTab">
    <b-tab title="Simple search">
      <SimpleSearch />
    </b-tab>
    <b-tab title="VLBI-IT search">
      <VLBI />
    </b-tab>
    <b-tab title="SD search">
      <SD />
    </b-tab>
    <b-tab title="Pulsar and transients search">
      <Pulsar />
    </b-tab>
  </b-tabs>
</div>
</template>

<script>
import SimpleSearch from './SimpleSearch.vue';
import VLBI from './VLBI.vue';
import SD from './SD.vue';
import Pulsar from './Pulsar.vue';
import {
  mapState
} from 'vuex';

export default {
  name: 'Form',
  components: {
    SimpleSearch,
    VLBI,
    SD,
    Pulsar
  },
  computed: mapState({
    searchForm: state => state.searchForm
  }),
  mounted() {
    document.getElementById('result-table-wrapper').addEventListener('scroll', function(ev) {
      // popovers have to follow result table wrapper horizontal scrolling
      let wrapperScrollLeft = document.getElementById('result-table-wrapper').scrollLeft;
      for (let popover of document.getElementsByClassName('popover')) {
        let scrollLeft = parseFloat(popover.getAttribute('data-scroll-left'));
        let left = parseFloat(popover.getAttribute('data-left')) + scrollLeft - wrapperScrollLeft;
        popover.style.left = left + 'px';
      }
    })
    window.toggleFrequencySupport = function(ev) {
      ev.preventDefault();

      // check if there is an already opened popover
      let popoverId = ev.target.getAttribute('data-popover-ref');
      let openedPopover = !!document.getElementById(popoverId);

      // remove popovers
      for (let popover of document.getElementsByClassName('popover')) {
        popover.remove();
      }

      if (openedPopover) {
        // close current popover and stop
        return;
      }

      let frequencyCellLink = ev.target;

      // Popover unique id (used for referencing popover from link)
      let id = Math.random().toString(36).substring(3);
      frequencyCellLink.setAttribute('data-popover-ref', id);

      let popover = document.createElement('div');
      popover.classList.add('popover', 'fade', 'show', 'bs-popover-top');
      popover.setAttribute('id', id);

      // Inital scroll left related to result table wrapper (must be updated during scroll)
      let scrollLeft = document.getElementById('result-table-wrapper').scrollLeft;
      popover.setAttribute('data-scroll-left', scrollLeft);

      let popoverArrow = document.createElement('div');
      popoverArrow.classList.add('arrow');
      popover.appendChild(popoverArrow);

      let popoverBody = document.createElement('div');
      popoverBody.classList.add('popover-body');
      popover.appendChild(popoverBody);

      popoverBody.innerHTML = frequencyCellLink.closest('.frequency-support-cell')
        .querySelector('.frequency-support-popover').innerHTML;

      let wrapperRect = document.getElementById('result-table-wrapper').getBoundingClientRect();
      let rect = frequencyCellLink.getBoundingClientRect();
      let left = rect.left - wrapperRect.left + 5;
      popover.style.left = left + 'px';
      popover.setAttribute('data-left', left);

      let top = rect.top - wrapperRect.top - 10 - 45 * popoverBody.querySelectorAll('tr').length - rect.height;
      popover.style.top = top + 'px';

      // append popover after link
      ev.target.insertAdjacentHTML("afterend", popover.outerHTML);
    }
  },
  methods: {
    tabChanged() {
      this.$store.commit('resetResults');
      this.$store.commit('tabChanged');
    }
  }
}
</script>

<style>
body {
  background: url('background.jpg');
}

#result-table {
  background: rgba(255, 255, 255, 0.5);
}

.frequency-support-popover {
  display: none;
}

.frequency-support-cell .popover {
  max-width: max-content;
}
</style>
